<template>
  <div class="c-h5p__wrapper">
    <slot name="instructions"></slot>
    <iframe
      :src="`https://fhus.h5p.com/content/${id}/embed`"
      :width="width"
      :height="height"
      frameborder="0"
      :tabindex="tabindex"
      allowfullscreen="allowfullscreen"
      allow="geolocation *; microphone *; camera *; midi *; encrypted-media *" />
  </div>
</template>

<script>
export default {
  name: 'fh-h5p',

  mounted() {
    // This should be done by H5P wrapper component
    if (!window.h5pResizerInitialized && !window.h5pResizerLoading) {
      window.h5pResizerLoading = true
      const el = document.createElement('script')

      el.src = 'https://fhus.h5p.com/js/h5p-resizer.js'
      el.onload = () => {
        window.h5pResizerLoading = false
      }

      document.head.appendChild(el)
    }
  },

  props: {
    id: String,
    width: String,
    height: String,
    tabindex: {
      type: String,
      default: "0"
    }
  }
}
</script>

<style lang="scss">
.c-h5p__wrapper {
  width: 100%;
  margin: 0 auto;
}
</style>
